// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__32lor","info":"UpdateTermsInfo_info__23ep2"};